import { Editor, Path, Transforms } from 'slate';
import { HistoryEditor } from 'slate-history';
import * as serializer from 'basic-editor-value-serializer';
import application from 'application';
import codes from 'event-system/codes/internal';

function flatten(nodes) {
  const result = [];
  for (const node of nodes) {
    if (['bulleted-list', 'numbered-list', 'list-item', 'bulleted-list-item', 'numbered-list-item'].includes(node.type)) {
      result.push(...flatten(node.children));
    } else if (typeof node.text === 'string' || node.type === 'link') {
      result.push(serializer.utilities.node.paragraph.buildNode({ children: [node] }));
    } else {
      result.push(node);
    }
  }
  return result;
}

function copy(nodes) {
  return JSON.parse(JSON.stringify(nodes));
}

function isPlainText(fragment) {
  if (fragment.length !== 1 || fragment[0].type !== 'paragraph') {
    return false;
  }
  for (const child of fragment[0].children) {
    if (child.type === 'link') {
      return false;
    }
  }
  return true;
}

export function withHeaderPaste(editor) {
  const insertFragment = editor.insertFragment;
  editor.insertFragment = function pasteHeader(fragment, options) {
    const header = Editor.above(editor, { match(node) { return node.type === 'site-nav'; } });
    if (!header || (options && options.at) || isPlainText(fragment)) {
      return insertFragment(fragment, options);
    }
    const region = Editor.above(editor, { match(node) { return ['navigation-start', 'navigation-end', 'submenu'].includes((node.properties || {}).role); } });
    const overflow = [];
    let items = [];
    if (region) {
      items = serializer.utilities.node.siteNav.normalizeItems(flatten(fragment), copy, overflow, region[0].properties.role === 'submenu');
    } else {
      overflow.push(...fragment);
    }
    HistoryEditor.withNewBatch(editor, function pasteContent() {
      Editor.withoutNormalizing(editor, function insertContent() {
        if (items.length > 0) {
          const item = Editor.above(editor, { match(node) { return node.type === 'site-nav-item'; } });
          let target = region[1].concat(region[0].children.length);
          if (item) {
            target = Path.next(item[1]);
          }
          Transforms.insertNodes(editor, items, { at: target });
        }
        if (overflow.length > 0) {
          Transforms.insertNodes(editor, overflow, { at: Path.next(header[1]) });
        }
      });
    });
    if (overflow.length > 0) {
      application.eventSystem.internal.emit(codes.DISPLAY_SYSTEM_TOAST_MESSAGE, { message: 'Some content was placed after the header.', seconds: 5, type: 'info' });
    }
  };
  return editor;
}
